/*
 * Разделы хранилищ на операторах — MongoDB (Percona), RabbitMQ и Valkey: у каждого свой пункт
 * меню и список Resource своего типа (те же колонки, что у баз данных и брокеров). Ресурсы
 * создают шаблоны «Кластер MongoDB / RabbitMQ / Valkey» в кластерах с соответствующим
 * оператором (галочка компонента в параметрах Kubernetes-кластера).
 */
import { Button } from '@material-ui/core';
import { EmptyState } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import {
  MONGODB_TYPE,
  RABBITMQ_TYPE,
  VALKEY_TYPE,
  routes,
} from '../../lib/viva';
import { SectionId } from '../../theme/sections';
import { EntityArgoAppsCell } from './cells';
import { datastoreColumns } from './columns';
import { TypedCatalogPage } from './TypedCatalogPage';

type OperatorDatastore = {
  section: SectionId;
  type: string;
  title: string;
  subtitle: string;
  nameTitle: string;
  /** «Создать кластер MongoDB» */
  createTitle: string;
  createTo: string;
  support: string;
  emptyTitle: string;
};

const operatorDatastorePage = (d: OperatorDatastore) => {
  const columns = datastoreColumns<CatalogTableRow>(d.nameTitle, row => (
    <EntityArgoAppsCell entity={row.entity} />
  ));
  return () => (
    <TypedCatalogPage
      section={d.section}
      title={d.title}
      subtitle={d.subtitle}
      kind="resource"
      type={d.type}
      columns={columns}
      create={{ title: d.createTitle, to: d.createTo }}
      support={d.support}
      emptyContent={
        <EmptyState
          missing="data"
          title={d.emptyTitle}
          description="Нужен Kubernetes-кластер с оператором (галочка компонента в параметрах кластера); запись появится здесь после регистрации в каталоге."
          action={
            <Button variant="contained" color="primary" href={d.createTo}>
              {d.createTitle}
            </Button>
          }
        />
      }
    />
  );
};

const GITOPS_NOTE =
  'values попадают в viva/gitops (datastores/<кластер>/…), ArgoCD выбранного кластера разворачивает его в namespace datastores, метрики и алерты — в VictoriaMetrics кластера.';

export const MongodbPage = operatorDatastorePage({
  section: 'mongodb',
  type: MONGODB_TYPE,
  title: 'MongoDB',
  subtitle:
    'Replica set MongoDB в кластерах платформы: оператор Percona, состояние в ArgoCD',
  nameTitle: 'Кластер MongoDB',
  createTitle: 'Создать кластер MongoDB',
  createTo: routes.newMongodb,
  support: `Кластер создаётся шаблоном «Кластер MongoDB»: ${GITOPS_NOTE}`,
  emptyTitle: 'Кластеров MongoDB пока нет',
});

export const RabbitmqPage = operatorDatastorePage({
  section: 'rabbitmq',
  type: RABBITMQ_TYPE,
  title: 'RabbitMQ',
  subtitle:
    'Кластеры RabbitMQ в кластерах платформы: RabbitMQ Cluster Operator, состояние в ArgoCD',
  nameTitle: 'Кластер RabbitMQ',
  createTitle: 'Создать кластер RabbitMQ',
  createTo: routes.newRabbitmq,
  support: `Кластер создаётся шаблоном «Кластер RabbitMQ»: ${GITOPS_NOTE}`,
  emptyTitle: 'Кластеров RabbitMQ пока нет',
});

export const ValkeyPage = operatorDatastorePage({
  section: 'valkey',
  type: VALKEY_TYPE,
  title: 'Valkey',
  subtitle:
    'Кластеры Valkey (cluster mode) в кластерах платформы: оператор valkey-operator, состояние в ArgoCD',
  nameTitle: 'Кластер Valkey',
  createTitle: 'Создать кластер Valkey',
  createTo: routes.newValkey,
  support: `Кластер создаётся шаблоном «Кластер Valkey»: ${GITOPS_NOTE}`,
  emptyTitle: 'Кластеров Valkey пока нет',
});
